import Header from "../Component/UserEnd/Header";
import TermsCond from "../Component/UserEnd/Terms&Cond";
import Footer from "../Component/UserEnd/Footer";

function TermsCondition() {
  return (
    <>
      <Header />
      <TermsCond />
      <Footer />
    </>
  );
}

export default TermsCondition;
